module.exports = __webpack_public_path__ + "img/contrato.51f4e96a.svg";